import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import styled from 'styled-components';
import { useThemeContext } from '../../styles/themes/themes.js';
import { IconCaretDown } from '../Icons/IconCaretDown.js';
import { IconCaretUp } from '../Icons/IconCaretUp.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var StyledDivContainer = styled.div.withConfig({
  displayName: "DataPill__StyledDivContainer",
  componentId: "sc-1ppfcgv-0"
})(["&&{align-items:center;background-color:", ";border-radius:4px;border:1px solid ", ";display:flex;flex-basis:0;flex-direction:column;flex-grow:1;height:64px;justify-content:center;max-width:calc(50% - 4px);min-width:calc(50% - 4px);}"], function (props) {
  return props.theme.neutralColors.white;
}, function (props) {
  return props.theme.neutralColors.silver;
});
var StyledValue = styled.div.withConfig({
  displayName: "DataPill__StyledValue",
  componentId: "sc-1ppfcgv-1"
})(["&&{color:", ";color:", ";color:", ";font-size:24px;line-height:30px;font-weight:600;}"], function (props) {
  return props.theme.neutralColors.smoke;
}, function (props) {
  return props.polarity === "positive" && props.theme.alertColors.success;
}, function (props) {
  return props.polarity === "negative" && props.theme.alertColors.error;
});
var StyledLabel = styled.div.withConfig({
  displayName: "DataPill__StyledLabel",
  componentId: "sc-1ppfcgv-2"
})(["&&{color:", ";font-size:12px;line-height:16px;}"], function (props) {
  return props.theme.neutralColors.smoke;
});
var useLocalizePolarity = function useLocalizePolarity(polarity) {
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var invertPolarityLanguageCodes = ["ja-JP", "ko-KR", "zh-CN", "zh-TW"];
  var invertpolarity = (localization === null || localization === void 0 ? void 0 : localization.languageCode) && invertPolarityLanguageCodes.includes(localization === null || localization === void 0 ? void 0 : localization.languageCode);
  var localizePolarity = function localizePolarity() {
    if (invertpolarity && polarity !== "neutral") {
      if (polarity === "positive") return "negative";
      return "positive";
    }
    return polarity;
  };
  return localizePolarity();
};
var DataPill = function DataPill(props) {
  var label = props.label,
    _props$polarity = props.polarity,
    polarity = _props$polarity === void 0 ? "neutral" : _props$polarity,
    tooltipProps = props.tooltipProps,
    value = props.value;
  var localizedPolarityStyle = useLocalizePolarity(polarity);
  var renderedJsx = /*#__PURE__*/jsxs(StyledDivContainer, {
    children: [/*#__PURE__*/jsx(StyledLabel, {
      children: label
    }), /*#__PURE__*/jsxs(StyledValue, {
      polarity: localizedPolarityStyle,
      children: [/*#__PURE__*/jsx("span", {
        children: value
      }), polarity !== "neutral" && (polarity === "positive" ? /*#__PURE__*/jsx(IconCaretUp, {
        size: 16
      }) : /*#__PURE__*/jsx(IconCaretDown, {
        size: 16
      }))]
    })]
  });
  var container = tooltipProps ? /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipProps), {}, {
    children: renderedJsx
  })) : renderedJsx;
  return container;
};
DataPill.displayName = "DataPill";

export { DataPill };
